import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from '../app/pages/pages';
import { AppConstants } from '../app/shared/app-constants';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MaterialModule } from '../app/shared/material.module';
import { LayoutModule } from '@angular/cdk/layout';
import { AuthenticationService } from '../app/services/authentication.service';
import { HttpClientModule } from '@angular/common/http';
import { RestService } from '../app/services/rest-service';
import { environment } from 'src/environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from '../app/services/jwt-interceptor';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { SitesComponent } from './pages/sites/sites.component';
import { SpinnerService } from './components/spinner-component/spinner.service';
import { MonitorsComponent } from './pages/monitors/monitors.component';
import { PrivilegeComponent } from './pages/privilege/privilege.component';
import { RolesComponent } from './pages/roles/roles.component';
import { UserManagementComponent as AdminUserManagementComponent } from './pages/user-management/user-management.component';
import { SpinnerComponentComponent } from './components/spinner-component/spinner-component.component';
import { ConfirmationDialogueComponent } from './components/confirmation-dialogue/confirmation-dialogue.component';
import { EditDeleteRendererComponent } from './components/edit-delete-renderer/edit-delete-renderer.component';
import { SafePipe, SiteDetailsComponent } from './pages/sites/site-details/site-details.component';
import { GraphStatsComponent, DetailsDialog, CamdetailsDialog } from './pages/graph-stats/graph-stats.component';
import { SiteOverviewComponent } from './pages/site-overview/site-overview.component';
import { ChartjsModule } from './pages/chartjs/chartjs.module';
import { X3HealthMonitoringComponent } from './pages/x3-health-monitoring/x3-health-monitoring.component';
import { SdtFormComponent } from './pages/sdt-form/sdt-form.component';
import { SdtDetailsComponent } from './pages/sdt-details/sdt-details.component';
import { SdtService } from './services/sdt.service';
import { DatePipe } from '@angular/common';
import { NetworkMetricsComponent } from './pages/network-metrics/network-metrics.component';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { SolarScriptDialogComponent } from './pages/solar-script/solar-script-dialog/solar-script-dialog.component';
import { CameraMetaDataComponent } from './pages/camera-meta-data/camera-meta-data.component';
import { MdcDataComponent } from './pages/mdc-data/mdc-data.component';
import { ZendeskCommentsComponent } from './pages/zendesk-comments/zendesk-comments.component';
import { PerformanceDashboardComponent } from './pages/performance-dashboard/performance-dashboard.component';
import { HelpComponent } from './pages/help/help.component';
import { ViewScriptComponent } from './pages/sites/view-script/view-script.component';
import { RouterInfoComponent } from './pages/router-info/router-info.component';
import { AccountConfigurationComponent } from './pages/account-configuration/account-configuration.component';
import { AccountHistoryComponent } from './pages/account-history/account-history.component';
import { PmFormComponent } from './pages/pm-form/pm-form.component';
import { PmDetailsComponent } from './pages/pm-details/pm-details.component';
import { JiraProjectReportsComponent } from './pages/jira-project-reports/jira-project-reports.component';
import {NgxPanZoomModule} from 'ngx-panzoom';
import { UserBehaviourModule } from './components/user-behaviour/user-behaviour.module';
import { CameraServerModule } from './camera-server/camera-server.module';
import { IframeModalComponent } from './iframe-modal/iframe-modal.component';
// User Behaviour standalone components
import { UserManagementComponent } from './components/user-behaviour/user-management/user-management.component';
import { AddEditUserDialogComponent } from './components/user-behaviour/dailogs/add-edit-user-dialog/add-edit-user-dialog.component';
import { EventTimelineComponent } from './components/user-behaviour/health/event-timeline.component';
import { EventDetailsDialogComponent } from './components/user-behaviour/health/eventdetails-dialog-component';
import { PopupComponent } from './components/user-behaviour/cam-view/popup-component';
import { LogViewerDialogComponent } from './components/user-behaviour/archive-dashboard/log-viewer-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    SitesComponent,
    MonitorsComponent,
    PrivilegeComponent,
    RolesComponent,
    AdminUserManagementComponent,
    SpinnerComponentComponent,
    EditDeleteRendererComponent,
    ConfirmationDialogueComponent,
    SiteDetailsComponent,
    SafePipe,
    GraphStatsComponent,
    SiteOverviewComponent,
    DetailsDialog,
    CamdetailsDialog,
    NetworkMetricsComponent,
    CameraMetaDataComponent,
    ZendeskCommentsComponent,
    PerformanceDashboardComponent,
    HelpComponent,
    RouterInfoComponent,
    AccountConfigurationComponent,
    AccountHistoryComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    FontAwesomeModule,
    MaterialModule,
    LayoutModule,
    AgGridModule,
    PmFormComponent,
    PmDetailsComponent,
    JiraProjectReportsComponent,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      maxOpened: 1,
      autoDismiss: true
    }),
    NgxSpinnerModule,
    ChartjsModule,
    NgxGoogleAnalyticsModule.forRoot(environment.ga),
    NgxGoogleAnalyticsRouterModule.forRoot({ include: ['/*'] }),
    UserBehaviourModule,
    CameraServerModule,
    // Standalone components
    MdcDataComponent,
    SolarScriptDialogComponent,
    SdtDetailsComponent,
    SdtFormComponent,
    ViewScriptComponent,
    X3HealthMonitoringComponent,
    IframeModalComponent,
    PmDetailsComponent,
    PmFormComponent,
    // User Behaviour standalone components
    UserManagementComponent,
    AddEditUserDialogComponent,
    EventTimelineComponent,
    EventDetailsDialogComponent,
    PopupComponent,
    LogViewerDialogComponent
  ],
  exports: [
    MaterialModule,
    HeaderComponent,
    FooterComponent,
    SpinnerComponentComponent
  ],
  providers: [
    AuthenticationService,
    RestService,
    SpinnerService,
    SdtService,
    DatePipe,
    [
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    ],
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }